import type { TripStatusType, TTransportType, TTransportStatus } from 'api/swagger';

export interface ITransportAvailabilityStatusProps {
  status: TripStatusType;
  transportId: number;
  transportType: TTransportType;
}

export const ETransportAvailabilityStatusRecord: Record<TTransportStatus, TTransportStatus> = {
  free: 'free',
  busy: 'busy',
};
